import Flatpickr from 'flatpickr/dist/flatpickr';
import { Dutch } from 'flatpickr/dist/l10n/nl.js';

export default class DateTimePicker {
    #datePickerConfig = {
        dateFormat: 'd-m-Y',
        minuteIncrement: 30,
        weekNumbers: true,
        locale: Dutch,
    };
    #dateTimePickerConfig = {
        enableTime: true,
        dateFormat: 'd-m-Y H:i',
        minuteIncrement: 30,
        time_24hr: true,
        weekNumbers: true,
        locale: Dutch,
    };

    constructor(element, includeTime = false) {
        let timeEnabled = element.dataset.enableTime ?? includeTime;

        timeEnabled
            ? Flatpickr(element, this.#dateTimePickerConfig)
            : Flatpickr(element, this.#datePickerConfig);
    }

    static initAll(selector, includeTime) {
        Array.from(document.querySelectorAll(selector), (element) => new DateTimePicker(element, includeTime));
    }
}
